import { render, staticRenderFns } from "./OutgoingDetail.vue?vue&type=template&id=6ca088f4&scoped=true&"
import script from "./OutgoingDetail.vue?vue&type=script&lang=js&"
export * from "./OutgoingDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutgoingDetail.vue?vue&type=style&index=0&id=6ca088f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca088f4",
  null
  
)

export default component.exports